var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"file-preview"},[_c('vue-dropzone',{ref:"myVueDropzone",attrs:{"id":"dropzone","options":_vm.dropzoneOptions},on:{"vdropzone-file-added":_vm.fileAdded,"vdropzone-max-files-exceeded":_vm.maxfilesexceeded}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }